import React from "react";

import Button from "../ui/Button";

const noop = () => {};

/**
 * The form submit control, rendered as the style-guide Button.
 *
 * Contract (unchanged for every caller):
 *   - no `onClick` → type="submit" (submits the enclosing form);
 *     with `onClick` → type="button" running that handler
 *   - `isSubmitting` → disabled, with the Button's spinner in place of the label
 *   - label: `children`, else `label`, else "Save"
 * `variant` / `size` and any other prop (data-btn, aria-*) pass through to Button.
 */
const Submit = ({
  isSubmitting = false,
  onClick,
  className = "",
  children,
  label,
  variant = "primary",
  size = "lg",
  ...rest
}) => (
  <Button
    type={onClick ? "button" : "submit"}
    variant={variant}
    size={size}
    className={className}
    onClick={onClick || noop}
    disabled={isSubmitting}
    loading={isSubmitting}
    {...rest}
  >
    {children || label || "Save"}
  </Button>
);

export default Submit;
